import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    acknowledge: {
      marginLeft: theme.spacing(1),
    },
    defaultAlert: {
      color: theme.palette.info.light,
    },
    nonDefaultAlert: {
      color: theme.palette.grey[100],
    },
  })
);
